import { Clock4, LucideCalendarDays, Radio } from "lucide-react";
import React, { useState } from "react";
import EventModal from "../../../../components/ui/EventModal";

const PastEventCard = ({ event, displayNumber }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getHeaderTitle = () => {
    if (event.category === 'webinar') {
      return `Webinar #${displayNumber}`;
    } else if (event.category === 'competitions') {
      return `Competitions #${displayNumber}`;
    }
    return `Event #${displayNumber}`;
  };

  const handleViewDetails = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="w-full h-full bg-white overflow-hidden flex flex-col items-start drop-shadow-md">
      {/* Header Banner - Different color for past events */}
      <div className="bg-gray-600/80 py-2 px-3 text-white rounded-t-xl">
        <h3 className="text-lg font-semibold">{getHeaderTitle()}</h3>
      </div>

      <div className="flex-1 rounded-tr-2xl rounded-b-2xl overflow-hidden shadow-lg flex flex-col w-full">
        {/* Background Image Section */}
        <div
          className="h-48 w-full relative overflow-hidden"
          style={{
            backgroundImage: `linear-gradient(135deg, #9ca3af 0%, #6b7280 50%, #4b5563 100%)`,
          }}
        >
          {/* Black and white image */}
          <img
            src={event.image}
            alt={event.title}
            className="w-full h-full object-cover opacity-70 grayscalex"
          />
          
          {/* Diagonal stripe pattern overlay */}
          {/* <div 
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 10px,
                rgba(0, 0, 0, 0.1) 10px,
                rgba(0, 0, 0, 0.1) 20px
              )`
            }}
          ></div> */}
          
          {/* Additional overlay for depth */}
          <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        </div>

        {/* Content Section */}
        <div className="p-4 flex-1 flex flex-col bg-Color-White w-full">
          {/* Title */}
          <div className="mb-4 w-full">
            <h2 className="text-xl font-semibold text-gray-900 mb-3 leading-tight w-full">
              {event.title}
            </h2>

            {/* Attendee Count - Only show if attendeeCount exists */}
            {event.attendeeCount && (
              <p className="text-Color-Black text-base mb-4">
                {event.attendeeCount} people attended this event
              </p>
            )}
          </div>

          {/* Event Details */}
          <div className="space-y-3 mb-6 flex-1">
            {/* Brief */}
            {event.brief && (
              <div className="text-Color-Black">
                <p className="text-base">{event.brief}</p>
              </div>
            )}
            
            {/* Date */}
            {event.date && (
              <div className="flex items-center text-Color-Black">
                <LucideCalendarDays className="size-5 text-gray-700 mr-2" />
                <span className="text-base font-medium">{event.date}</span>
              </div>
            )}

            {/* Time */}
            {event.time && (
              <div className="flex items-center text-Color-Black">
                <Clock4 className="size-5 text-gray-700 mr-2" />
                <span className="text-base font-medium">{event.time}</span>
              </div>
            )}
           

            {/* Platform */}
            {event.platform && (
              <div className="flex items-center text-Color-Black">
                <Radio className="size-5 text-gray-700 mr-2" />
                <span className="text-base font-medium">{event.platform}</span>
              </div>
            )}
          </div>

          {/* Action Buttons - Different for past events */}
          <div className="flex gap-3 mt-auto">
            <button 
              onClick={handleViewDetails}
              className="flex-1 bg-transparent border border-gray-300 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 text-sm"
            >
              VIEW DETAILS
            </button>
            <button className="flex-1 bg-gray-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-gray-700 transition-colors duration-200 text-sm">
              EXPIRED
            </button>
          </div>
        </div>
      </div>

      {/* Event Modal */}
      <EventModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        event={event}
        isUpcoming={false}
      />
    </div>
  );
};

export default PastEventCard;